import i18next from 'i18next'
import {TRANSLATIONS} from 'src/common/i18n/translations'
import {DEFAULT_LANGUAGE_CODE, getLanguageCode} from 'src/common/utils/locale'

export type Translate = (key: string, values?: Record<string, string | number>) => string

export const createTranslator = (locale: string): Translate => {
  const instance = i18next.createInstance()

  instance.init({
    resources: TRANSLATIONS,
    lng: getLanguageCode(locale),
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    initImmediate: false,
    interpolation: {escapeValue: false},
  })

  return (key, values) => instance.t(key, values)
}
